const SEXOS = [
	//{ value: "W" , label: "Semanal", identifier:'WEEKLY' },
  { value: "M" , label: "Mensal", identifier:'MONTHLY' },
	{ value: "B" , label: "Bimestral", identifier:'BIMONTHLY' },
	{ value: "T" , label: "Trimestral", identifier:'TRIMONTHLY' },
	{ value: "S" , label: "Semestral", identifier:'SEMIANNUALLY' },
	{ value: "Y" , label: "Anual", identifier:'YEARLY'}
];

export default SEXOS;



// WEBPACK FOOTER //
// ./src/data/Periodicidade.js